import { useState, useRef, Fragment } from 'react';
// import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useHookStore } from '../../hook-store/store';

// import { IMAGEPHOTO_BACKENDURL, kuraImagePhotoUrl } from '../../lib/api';

import { marks } from '../../utils/marks';

// import IpaInputImage from '../../image/for-iopaint/image-prompt/boy-man-h200.png';
// import IpaIpaImage from '../../image/for-iopaint/image-prompt/statue-h200.png';
// import IpaResultImage from '../../image/for-iopaint/image-prompt/boy-man-ipa2-h200.png';
// import IpaMaskImage from '../../image/for-iopaint/image-prompt/boy-man-ipa2-mask-h200.png';

import SchInputImage1 from '../../image/for-style-change/for-about/sch-input-manwoman-h125.jpg';
import SchMaskImage1 from '../../image/for-style-change/for-about/sch-mask-manwoman-1-h100.jpeg'
import SchStyleImage1 from '../../image/for-style-change/for-about/sch-style-oil-painting-h100.jpeg'
import SchOutputImage1 from '../../image/for-style-change/for-about/sch-manwoman-output-oil-painting-style-h125.jpeg'

import SchMaskImage2 from '../../image/for-style-change/for-about/sch-mask-manwoman-2-h100.jpeg'
import SchOutputImage2 from '../../image/for-style-change/for-about/sch-output-manwoman-2-h125.jpeg'

import SchInputImage3 from '../../image/for-style-change/for-about/sch-turban-woman-input-h125.jpeg';
import SchMaskImage3 from '../../image/for-style-change/for-about/sch-turban-woman-mask-h100.jpeg'
import SchStyleImage3 from '../../image/for-style-change/for-about/sch-style-origami-crop-h125.jpeg'
import SchOutputImage3 from '../../image/for-style-change/for-about/sch-turban-woman-origami-style-h125.jpeg'

import SchInputImage4 from '../../image/for-style-change/for-about/sch-road-input-h125.jpeg';
import SchMaskImage4 from '../../image/for-style-change/for-about/sch-road-mask-h100.jpeg'
import SchStyleImage4 from '../../image/for-style-change/for-about/sch-style-cartoon-crop-h100.jpeg'
import SchOutputImage4 from '../../image/for-style-change/for-about/sch-road-output-cartoon-style-h125.jpeg'

import SchStyleImage5 from '../../image/for-style-change/for-about/sch-style-abstract-crop-h100.jpeg'
import SchStyleImage6 from '../../image/for-style-change/for-about/sch-style-watercolor-crop-h125.jpeg'
import SchStyleImage7 from '../../image/for-style-change/for-about/sch-style-sketch-style-h100.png'
import SchStyleImage8 from '../../image/for-style-change/for-about/sch-style-lego-crop-h125.jpeg'

import SchOutputImage5 from '../../image/for-style-change/for-about/more-image/turban-woman-output-abstract-h125.jpeg'
import SchOutputImage6 from '../../image/for-style-change/for-about/more-image/turban-woman-output-watercolor-h125.jpeg'
import SchOutputImage7 from '../../image/for-style-change/for-about/more-image/turban-woman-output-sketch-h125.jpeg'
import SchOutputImage8 from '../../image/for-style-change/for-about/more-image/turban-woman-output-lego-h125.jpeg'

import SchInputImage9 from '../../image/for-style-change/for-about/sch-turban-woman-input-h125.jpeg';
import SchMaskImage9 from '../../image/for-style-change/for-about/sch-turban-woman-mask-h100.jpeg'
import SchStyleImage9 from '../../image/for-style-change/for-about/sch-style-oil-painting-h100.jpeg'
import SchOutputImage9 from '../../image/for-style-change/for-about/more-image/turban-woman-output-oil-h125.jpeg'

import SchInputImage10 from '../../image/for-style-change/for-about/sch-road-input-h125.jpeg';
import SchMaskImage10 from '../../image/for-style-change/for-about/sch-road-mask-h100.jpeg'
import SchStyleImage10 from '../../image/for-style-change/for-about/sch-style-oil-painting-h100.jpeg'
import SchOutputImage10 from '../../image/for-style-change/for-about/more-image/road-output-oil-h125.jpeg'

import SchInputImage11 from '../../image/for-style-change/for-about/sch-input-mountain-h125.jpeg';
import SchMaskImage11 from '../../image/for-style-change/for-about/sch-mountain-mask-h100.jpeg'
import SchStyleImage11 from '../../image/for-style-change/for-about/sch-style-oil-painting-h100.jpeg'
import SchOutputImage11 from '../../image/for-style-change/for-about/more-image/mountain-output-oil-h125.jpeg'

// import { marks } from '../../utils/marks';
import classes from './AboutIopaint.module.css';



function AboutStyleChange(props) {
  const { } = props;

  const [t] = useTranslation('translation');

  // const bgRemoveRef = useRef(null);
  // const illustGeneratorRef = useRef(null);

  const [hStore, hDispatch] = useHookStore();
  // console.log('store-BucketObjects.js', store);

  // const [showControlNetDesc, setShowControlNetDesc] = useState(false);

  const [showMoreImages, setShowMoreImages] = useState(false);
 

  

  let aboutStyleChangeBody;

  aboutStyleChangeBody = (
    <div>
      <div>
        In Style Change, 
        {' '}
        {t('aboutStyleChange01', 'user can generate image with styles of Style image.')}
        <br/>
        {t('aboutStyleChange02', 'Styles are transfered into specific parts of the Input image without affecting other parts.')}
        <br/>
        {t('aboutStyleChange03', 'User can control how much styles are transfered by changing input values.')}
      </div>
      <br/>

      <div>
        {t('aboutStyleChange04', 'Styles of style image are transfered to selected part of input image.')}
      </div>
      <br/>

      <div>
        <div className={classes.aboutIopaintImageContainer}>
          <div>
            <img className={classes.aboutIopaintImage}
              style={{height: "125px"}}
              src={SchInputImage1}
            />
            <div>{t('aboutPage.13', 'Input image')}</div>
          </div>
          <div>
            <img className={classes.aboutIopaintImage}
              style={{height: "125px"}}
              src={SchMaskImage1}
            />
            <div>{t('aboutStyleChange05', 'Selected part')}</div>
          </div>
          <div>
            <img className={classes.aboutIopaintImage}
              style={{height: "125px"}}
              src={SchStyleImage1}
            />
            <div>{t('aboutStyleChange06', 'Style image')} (oil painting)</div>
          </div>
          <div>
            <img className={classes.aboutIopaintImage}
              style={{height: "125px"}}
              src={SchOutputImage1}
            />
            <div>{t('aboutStyleChange07', 'Output image')}</div>
          </div>
        </div>
        <br/>

        <div className={classes.aboutIopaintImageContainer}>
          <div>
            <img className={classes.aboutIopaintImage}
              style={{height: "125px"}}
              src={SchInputImage1}
            />
            <div>{t('aboutPage.13', 'Input image')}</div>
          </div>
          <div>
            <img className={classes.aboutIopaintImage}
              style={{height: "125px"}}
              src={SchMaskImage2}
            />
            <div>{t('aboutStyleChange05', 'Selected part')}</div>
          </div>
          <div>
            <img className={classes.aboutIopaintImage}
              style={{height: "125px"}}
              src={SchStyleImage1}
            />
            <div>{t('aboutStyleChange06', 'Style image')} (oil painting)</div>
          </div>
          <div>
            <img className={classes.aboutIopaintImage}
              style={{height: "125px"}}
              src={SchOutputImage2}
            />
            <div>{t('aboutStyleChange07', 'Output image')}</div>
          </div>
        </div>
        <br/>

        <div className={classes.aboutIopaintImageContainer}>
          <div>
            <img className={classes.aboutIopaintImage}
              style={{height: "125px"}}
              src={SchInputImage3}
            />
            <div>{t('aboutPage.13', 'Input image')}</div>
          </div>
          <div>
            <img className={classes.aboutIopaintImage}
              style={{height: "125px"}}
              src={SchMaskImage3}
            />
            <div>{t('aboutStyleChange05', 'Selected part')}</div>
          </div>
          <div>
            <img className={classes.aboutIopaintImage}
              style={{height: "125px"}}
              src={SchStyleImage3}
            />
            <div>{t('aboutStyleChange06', 'Style image')} (origami)</div>
          </div>
          <div>
            <img className={classes.aboutIopaintImage}
              style={{height: "125px"}}
              src={SchOutputImage3}
            />
            <div>{t('aboutStyleChange07', 'Output image')}</div>
          </div>
        </div>
        <br/>

        <div className={classes.aboutIopaintImageContainer}>
          <div>
            <img className={classes.aboutIopaintImage}
              style={{height: "125px"}}
              src={SchInputImage4}
            />
            <div>{t('aboutPage.13', 'Input image')}</div>
          </div>
          <div>
            <img className={classes.aboutIopaintImage}
              style={{height: "125px"}}
              src={SchMaskImage4}
            />
            <div>{t('aboutStyleChange05', 'Selected part')}</div>
          </div>
          <div>
            <img className={classes.aboutIopaintImage}
              style={{height: "125px"}}
              src={SchStyleImage4}
            />
            <div>{t('aboutStyleChange06', 'Style image')} (cartoon)</div>
          </div>
          <div>
            <img className={classes.aboutIopaintImage}
              style={{height: "125px"}}
              src={SchOutputImage4}
            />
            <div>{t('aboutStyleChange07', 'Output image')}</div>
          </div>
        </div>
        <br/>

        <div>
          <span
            onClick={() => { 
              setShowMoreImages(!showMoreImages) 
            }}
          >
            More images {marks.triangleDown}
          </span>
        </div>
        <br/>
        
        {showMoreImages && (
          <div>
            <div>
              {t('aboutStyleChange09', 'By changing Input image and Style image, various images are generated.')}
            </div>
            <br/>

            <div className={classes.aboutIopaintImageContainer}>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchInputImage3}
                />
                <div>{t('aboutPage.13', 'Input image')}</div>
              </div>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchMaskImage3}
                />
                <div>{t('aboutStyleChange05', 'Selected part')}</div>
              </div>
            </div>
            <br/>

            <div className={classes.aboutIopaintImageContainer}>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchStyleImage5}
                />
                {t('aboutStyleChange06', 'Style image')} (abstract painting)
              </div>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchOutputImage5}
                />
                <div>{t('aboutStyleChange07', 'Output image')}</div>
              </div>
            </div>
            <br/>

            <div className={classes.aboutIopaintImageContainer}>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchStyleImage6}
                />
                {t('aboutStyleChange06', 'Style image')} (watercolor painting)
              </div>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchOutputImage6}
                />
                <div>{t('aboutStyleChange07', 'Output image')}</div>
              </div>
            </div>
            <br/>

            <div className={classes.aboutIopaintImageContainer}>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px", width: "125px"}}
                  src={SchStyleImage7}
                />
                {t('aboutStyleChange06', 'Style image')} (sketch)
              </div>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchOutputImage7}
                />
                <div>{t('aboutStyleChange07', 'Output image')}</div>
              </div>
            </div>
            <br/>

            <div className={classes.aboutIopaintImageContainer}>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchStyleImage8}
                />
                {t('aboutStyleChange06', 'Style image')} (LEGO block)
              </div>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchOutputImage8}
                />
                <div>{t('aboutStyleChange07', 'Output image')}</div>
              </div>
            </div>
            <br/>

            <div className={classes.aboutIopaintImageContainer}>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchInputImage10}
                />
                <div>{t('aboutPage.13', 'Input image')}</div>
              </div>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchMaskImage10}
                />
                <div>{t('aboutStyleChange05', 'Selected part')}</div>
              </div>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchStyleImage10}
                />
                <div>{t('aboutStyleChange06', 'Style image')} (oil painting)</div>
              </div>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchOutputImage10}
                />
                <div>{t('aboutStyleChange07', 'Output image')}</div>
              </div>
            </div>
            <br/>

            <div className={classes.aboutIopaintImageContainer}>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchInputImage11}
                />
                <div>{t('aboutPage.13', 'Input image')}</div>
              </div>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchMaskImage11}
                />
                <div>{t('aboutStyleChange05', 'Selected part')}</div>
              </div>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchStyleImage11}
                />
                <div>{t('aboutStyleChange06', 'Style image')} (oil painting)</div>
              </div>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchOutputImage11}
                />
                <div>{t('aboutStyleChange07', 'Output image')}</div>
              </div>
            </div>
            <br/>

            <div className={classes.aboutIopaintImageContainer}>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchInputImage9}
                />
                <div>{t('aboutPage.13', 'Input image')}</div>
              </div>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchMaskImage9}
                />
                <div>{t('aboutStyleChange05', 'Selected part')}</div>
              </div>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchStyleImage9}
                />
                <div>{t('aboutStyleChange06', 'Style image')} (oil painting)</div>
              </div>
              <div>
                <img className={classes.aboutIopaintImage}
                  style={{height: "125px"}}
                  src={SchOutputImage9}
                />
                <div>{t('aboutStyleChange07', 'Output image')}</div>
              </div>
            </div>
            <br/>

          </div>
        )}
      </div>
    </div>
  )


  
  return (
    <Fragment>
      {aboutStyleChangeBody}
    </Fragment>
  );
}

export default AboutStyleChange;